// extracted by mini-css-extract-plugin
export default {"container":"EditorialContent_container__UtTnk"};